
const React = window.React ?? null;

import VimeoThumbnail from './VimeoThumbnail.jsx';
import VimeoButton from './VimeoButton.jsx';
import VimeoModal from './VimeoModal.jsx';

export default class VimeoCard extends React.Component {

    state = {
        vimeoData: {}
    };

    constructor(props) {
        super(props);     
    }

    async componentDidMount() {
        const data = await this.getVimeoData();

        this.setState({
            vimeoData: data
        });
    }

    get data() {
        return this.props.data;
    }

    get vimeoData() {
        return this.state.vimeoData;
    }

    getVideoUrl() {
        return `https://vimeo.com/${this.data.settings.video_id}`;
    }

    getEndpoint() {
        return `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(this.getVideoUrl())}`;
    }

    async getVimeoData() {
        try {
            const response = await fetch(this.getEndpoint());
            if (!response.ok) {
                console.error(`Error fetching Vimeo oEmbed data: ${response.status}`);
                return null;
            }
            return await response.json();
        } catch (error) {
            console.error('Error fetching or parsing Vimeo data:', error);
            return null;
        }
    }

    render() {
        if (!this.vimeoData) {
            return '';
        }

        const cardStyle = {
            maxWidth: (this.data.settings.card_max_width) ? this.data.settings.card_max_width : '100%', 
            backgroundColor: (this.data.settings.card_background_color) ? this.data.settings.card_background_color : 'transparent'
        };

        const content = (this.data.settings.content) ? this.data.settings.content : '';

        return (
            <div className={`vimeo-card p-3 ${this.data.settings.card_classes ?? ''}`} style={cardStyle}>
                <div className="thumbnail-container mb-3">
                    <VimeoThumbnail data={this.data} vimeoData={this.vimeoData ?? {}}/>
                </div>
                <div className="content-container">
                    <div className={`content ${this.data.settings.content_classes ?? ''}`} dangerouslySetInnerHTML={{__html: content}}></div>
                    <VimeoButton data={this.data} vimeoData={this.vimeoData ?? {}}/>
                </div>
                <VimeoModal data={this.data} vimeoData={this.vimeoData ?? {}}/>
            </div>
        );
    }
}
